
export const REQUEST_DEPARTMENT_LIST = 'REQUEST_DEPARTMENT_LIST';
export const REQUEST_DEPARTMENT_LIST_SUCCESS = 'REQUEST_DEPARTMENT_LIST_SUCCESS';
export const REQUEST_DEPARTMENT_LIST_ERROR = 'REQUEST_DEPARTMENT_LIST_ERROR';

export const REQUEST_LOCATION_LIST = 'REQUEST_LOCATION_LIST';
export const REQUEST_LOCATION_LIST_SUCCESS = 'REQUEST_LOCATION_LIST_SUCCESS';
export const REQUEST_LOCATION_LIST_ERROR = 'REQUEST_LOCATION_LIST_ERROR';

export const REQUEST_HOSPITAL_LIST = 'REQUEST_HOSPITAL_LIST';
export const REQUEST_HOSPITAL_LIST_SUCCESS = 'REQUEST_HOSPITAL_LIST_SUCCESS';
export const REQUEST_HOSPITAL_LIST_ERROR = 'REQUEST_HOSPITAL_LIST_ERROR';


export const REQUEST_PROMOTION_LIST = 'REQUEST_PROMOTION_LIST';
export const REQUEST_PROMOTION_LIST_SUCCESS = 'REQUEST_PROMOTION_LIST_SUCCESS';
export const REQUEST_PROMOTION_LIST_ERROR = 'REQUEST_PROMOTION_LIST_ERROR';